import { compact, compose, filter, get, includes, isEmpty, map, size, some, concat, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';
import { composeProps, createPropsExtender } from '@mews/framework';
import { Message as MessageType } from '@mews-commander/messages';
import { Member, Message } from '@mews-commander/legacy-data-structures';
import { getOrEmptyString, sortByAscending, getFullName, utcToLocalizedDateTime } from '@mews-commander/utils';
import { getCurrentEnterpriseMessagesByThreadId } from '@mews-commander/legacy-entities/src/ducks/messages';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { moduleSelector } from '../module';
import { draftsSelector, getMessages, loadingMessagesSelector } from './messages';
import { loadingMembersSelector, getCurrentThreadMembers } from './members';
import { getCurrentThreadId, isCurrentThreadStub } from './threads';

export const isEditingSubject = createSelector(moduleSelector, get('subjectEditMode'));
export const threadSubjectDraft = createSelector(moduleSelector, get('threadSubjectDraft'));
export const isMembersPanelVisible = createSelector(moduleSelector, get('membersVisible'));

export const currentThreadMembers = compose(
    // @ts-expect-error $TSFixMeError: Property 'fullName' does not exist on type
    orderBy(['isEmployee', ({ fullName }) => fullName.toLowerCase()], ['asc']),
    map((member) =>
        Member({
            // @ts-expect-error $TSFixMeError: Spread types may only be created from object types.
            ...member,
            // @ts-expect-error
            fullName: getFullName(member),
        })
    ),
    filter('isActive'),
    getCurrentThreadMembers
);

export const currentThreadMemberProfileIds = createSelector(currentThreadMembers, compose(compact, map('profileId')));

export const getAllMessages = createSelector(getCurrentEnterpriseMessagesByThreadId, getMessages, concat);

export const getCurrentEnterpriseCurrentThreadMessages = composeProps(
    getAllMessages,
    createPropsExtender('threadId', getCurrentThreadId)
);

const getThreadMessagesSorted = createSelector(
    getCurrentEnterpriseCurrentThreadMessages,
    sortByAscending<MessageType>('createdUtc')
);

export const currentThreadMessages = createSelector(
    getThreadMessagesSorted,
    getCurrentEnterpriseIanaTimeZoneIdentifier,
    (messages, timezone) =>
        map(
            // @ts-expect-error $TSFixMeError: Property 'createdUtc' does not exist on type '{}'.
            ({ createdUtc, ...other }) =>
                Message({
                    ...other,
                    created: utcToLocalizedDateTime(createdUtc, timezone),
                }),
            messages
        )
);

export const areCurrentMessagesLoading = createSelector(getCurrentThreadId, loadingMessagesSelector, includes);

export const areCurrentMembersLoading = createSelector(getCurrentThreadId, loadingMembersSelector, includes);

export const currentThreadDraft = createSelector([getCurrentThreadId, draftsSelector], getOrEmptyString);

export const canSendMessage = createSelector(
    [currentThreadMembers, currentThreadDraft, isCurrentThreadStub],
    (members, draft, isStub) => !isEmpty(draft) && size(members) > 1 && !isStub
);

export const threadHasError = createSelector(getMessages, some('isFailed'));
